// extracted by mini-css-extract-plugin
export var gif = "_dj-0";